import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { CorePayloadAlborDataEdition } from './albor-data-edition.types';
import { transformIntoQueryParamString } from '@old/utils/service';

// deprecated service ref.: updateIntegrationSettingsService_DEPRECATED
export async function updateAlborDataService({ query: rawQuery, body }: CorePayloadAlborDataEdition) {
  const query = transformIntoQueryParamString(rawQuery);

  const { response, data } = await BACKEND.put(ENDPOINT.ORGANIZATIONS, { query, body });

  return {
    response,
    summary: data,
  };
}
